export default __webpack_public_path__ + "static/media/male_avatar.35de5f31.svg";